import React from 'react'
import PropTypes from 'prop-types'

const TimeZone = ({ width = 24, height = 24, color = '#222222' }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height}>
    <defs>
      <clipPath id='a'>
        <path
          data-name='Rectangle 5149'
          transform='translate(356 -12895)'
          fill='none'
          stroke='#707070'
          d='M0 0h24v24H0z'
        />
      </clipPath>
    </defs>
    <g data-name='time zone icon' transform='translate(-356 12895)' clipPath='url(#a)'>
      <path
        d='M367.999-12874.001a8.767 8.767 0 0 1-3.51-.709 9.091 9.091 0 0 1-2.858-1.923 9.086 9.086 0 0 1-1.924-2.857 8.759 8.759 0 0 1-.708-3.511 8.767 8.767 0 0 1 .709-3.51 9.091 9.091 0 0 1 1.923-2.858 9.085 9.085 0 0 1 2.857-1.924 8.759 8.759 0 0 1 3.511-.708 8.768 8.768 0 0 1 3.51.709 9.092 9.092 0 0 1 2.858 1.923 9.087 9.087 0 0 1 1.924 2.857 8.758 8.758 0 0 1 .708 3.511 8.768 8.768 0 0 1-.709 3.51 9.092 9.092 0 0 1-1.923 2.858 9.088 9.088 0 0 1-2.857 1.924 8.761 8.761 0 0 1-3.511.708Zm-1-1.108v-1.915a1.828 1.828 0 0 1-1.385-.6 2 2 0 0 1-.563-1.417v-1.015l-4.773-4.773a9 9 0 0 0-.152.909 8.066 8.066 0 0 0-.052.919 7.776 7.776 0 0 0 1.97 5.279 7.547 7.547 0 0 0 4.955 2.615Zm6.854-2.521a7.794 7.794 0 0 0 .889-1.179 8.291 8.291 0 0 0 .656-1.316 7.415 7.415 0 0 0 .4-1.409 8.344 8.344 0 0 0 .129-1.467 7.92 7.92 0 0 0-1.346-4.485 7.737 7.737 0 0 0-3.617-2.943v.438a1.993 1.993 0 0 1-.563 1.414 1.828 1.828 0 0 1-1.385.6h-2.017v2.015a.844.844 0 0 1-.306.67 1.05 1.05 0 0 1-.706.263h-1.951v2.028h5.992a.853.853 0 0 1 .67.3 1.028 1.028 0 0 1 .263.7v2.962h1a1.915 1.915 0 0 1 1.19.393 1.953 1.953 0 0 1 .703 1.017Z'
        fill={color}
      />
    </g>
  </svg>
)

TimeZone.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string
}

export default TimeZone
